import { observable, action } from "mobx";
import { makeApi, URLS } from "Utils/apiURL";
import Utils from "Utils/utils";
import DateUtils from "Utils/DateUtils";
import userDetail from "Stores/userDetail";

const POLL_MS = 5 * 60 * 1000;

/*
 * Background counts for the left rail that no other store keeps globally (tasks today/late).
 * Same call and payload as the Tasks page's Due tab (task analytics v2, dueCount), only the end of the
 * window differs: now for late, end of today for due. Never blocks render; a failure leaves the count
 * unknown (null), which shows nothing.
 */
export const dueTasksPayload = (toDate, memberId, timeZone) => ({
  timeZone,
  status: "ACTIVE",
  memberIds: [memberId],
  tagIds: [],
  sequenceIds: [],
  contactFields: [],
  contactStage: [],
  taskType: null,
  pageNo: 1,
  dateFilter: { toDate }
});

class NavCounts {
  @observable tasksToday = null;
  @observable tasksLate = null;
  _timer = null;

  async taskTotal(toDate) {
    const res = await makeApi({
      url: URLS.getAccountTasksAnalytics,
      method: "POST",
      data: dueTasksPayload(toDate, userDetail?.userInfo?.memberId, Utils.getCurrentUserTimeZone())
    });
    const due = res?.data?.analyticsV2?.dueCount;
    return typeof due === "number" ? due : null;
  }

  @action.bound
  async fetchTasks() {
    const now = Date.now();
    const [due, late] = await Promise.all([this.taskTotal(DateUtils.getTimeStamp(new Date(), "end")), this.taskTotal(now)]);
    this.tasksLate = late;
    this.tasksToday = due == null || late == null ? null : Math.max(0, due - late);
  }

  start() {
    if (this._timer) return;
    this.fetchTasks();
    this._timer = setInterval(this.fetchTasks, POLL_MS);
  }

  stop() {
    if (this._timer) clearInterval(this._timer);
    this._timer = null;
  }
}

export const navCounts = new NavCounts();
